import { useCallback } from "react";
import { isEmpty } from "../../utils";

const eventsTracked = {};

const getEventParameters = (
  targetOrigin,
  formConfig,
  formData,
  event,
  parameters = {}
) => {
  if (!targetOrigin || !formConfig || !formData) {
    return null;
  }

  const eventKey = `${event}${parameters.lead_form_section_id || ""}`;
  if (eventsTracked[eventKey]) {
    return null;
  }

  eventsTracked[eventKey] = "completed";

  const eventParameters = {
    content_type: event,
    lead_form: "Multi Step",
    lead_form_domain: targetOrigin.replace(/^(https?:|)\/\//, ""),
    lead_form_config: formConfig,
    lead_form_src: formData.SRC,
    lead_form_test_lead: formData.Test_Lead ? `${formData.Test_Lead}` : "0",
    ...parameters,
  };

  if (!isEmpty(formData.Project)) {
    eventParameters.lead_form_project = formData.Project;
  }

  return eventParameters;
};

const useTrackGAEvents = (targetOrigin, formConfig, formData) => {
  const trackGAEvent = useCallback(
    function trackGAEvent(event, parameters = {}) {
      const eventParameters = getEventParameters(
        targetOrigin,
        formConfig,
        formData,
        event,
        parameters
      );

      if (eventParameters) {
        window.top.postMessage(
          {
            action: "lgp:ga:track-event",
            payload: {
              event: "select_content",
              parameters: eventParameters,
            },
          },
          targetOrigin
        );
      }
    },
    [targetOrigin, formConfig, formData]
  );

  return trackGAEvent;
};

export default useTrackGAEvents;
